import type { Component } from 'vue'

import type {
  ReviewsTag,
  ReviewsTagSentiment,
} from '@backmarket/nuxt-layer-reviews/api/reviews/types'
import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'
import { IconCheckInCircleFilled } from '@ds/icons/IconCheckInCircleFilled'
import { IconCrossInCircleFilled } from '@ds/icons/IconCrossInCircleFilled'
import { IconEqualInCircleFilled } from '@ds/icons/IconEqualInCircleFilled'

import translations from './AITags.translations'

export function formatRawTag(tag: string) {
  return (
    tag.charAt(0).toLocaleUpperCase() +
    tag.slice(1).toLowerCase().replace(/_/g, ' ')
  )
}

export const tagToLabel: Record<ReviewsTag, I18nDefinition> = {
  QUALITY: translations.quality,
  CONDITION: translations.condition,
  AUTHENTICITY: translations.authenticity,
  PERFORMANCE: translations.performance,
  BATTERY: translations.battery,
  SCREEN: translations.screen,
  TOUCHSCREEN: translations.touchscreen,
  DESIGN: translations.design,
  VALUE_FOR_MONEY: translations.valueForMoney,
  DELIVERY: translations.delivery,
  CUSTOMER_SERVICE: translations.customerService,
  ACCESSORIES: translations.accessories,
  ACCESSORY_COMPATIBILITY: translations.accessoryCompatibility,
  CAMERA: translations.camera,
  CONNECTIVITY: translations.connectivity,
  CALL_QUALITY: translations.callQuality,
  BIOMETRIC_SECURITY: translations.biometricSecurity,
  STORAGE_CAPACITY: translations.storageCapacity,
  UNLOCKED_STATUS: translations.unlockedStatus,
  SOFTWARE: translations.software,
  WATER_RESISTANCE: translations.waterResistance,
  KEYBOARD: translations.keyboard,
  TRACKPAD: translations.trackpad,
  PORTS: translations.ports,
  WEBCAM: translations.webcam,
  COOLING: translations.cooling,
  NOISE_LEVEL: translations.noiseLevel,
  AUDIO: translations.audio,
  PORTABILITY: translations.portability,
  CELLULAR_CONNECTIVITY: translations.cellularConnectivity,
  STRAP_QUALITY: translations.strapQuality,
  FITNESS_TRACKING: translations.fitnessTracking,
  GPS_ACCURACY: translations.gpsAccuracy,
  NOTIFICATIONS: translations.notifications,
  APP_COMPATIBILITY: translations.appCompatibility,
  FIT: translations.fit,
  PROTECTION: translations.protection,
  MATERIAL_QUALITY: translations.materialQuality,
  BUTTON_ACCESS: translations.buttonAccess,
  TRANSPARENCY: translations.transparency,
  UPGRADABILITY: translations.upgradability,
  EASE_OF_USE: translations.easeOfUse,
  CAPACITY: translations.capacity,
  ENERGY_EFFICIENCY: translations.energyEfficiency,
}

export const sentimentToIcon: Record<ReviewsTagSentiment, Component> = {
  positive: IconCheckInCircleFilled,
  neutral: IconEqualInCircleFilled,
  negative: IconCrossInCircleFilled,
}
